/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum org_coursera_payment_transaction_PaymentTransactionActionType {
  CHARGEBACK = "CHARGEBACK",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PAYMENT = "PAYMENT",
  QUERY = "QUERY",
  REFUND = "REFUND",
  VOID = "VOID",
}

export enum org_coursera_product_BillingCycle {
  ANNUAL = "ANNUAL",
  BIANNUAL = "BIANNUAL",
  MONTHLY = "MONTHLY",
}

export enum OnDemandSpecializationMembershipRole {
  INSTRUCTOR = 'INSTRUCTOR',
  LEARNER = 'LEARNER',
  NEVER_ENROLLED = 'NEVER_ENROLLED',
  NOT_ENROLLED = 'NOT_ENROLLED',
  UNIVERSITY_ADMIN = 'UNIVERSITY_ADMIN',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
